import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme";
import { useAuth } from "./context/AuthContext";

// Layout Components
import Header from "./components/layout/Header";

// Auth Components
import Login from "./components/auth/Login";
import Register from "./components/auth/Register";

// Battle Components
import CreateBattle from "./components/battle/CreateBattle";
import BattleDisplay from "./components/battle/BattleDisplay";

// Dashboard Components
import Dashboard from "./components/dashboard/Dashboard";

// Subscription Components
import SubscriptionPlans from "./components/subscription/SubscriptionPlans";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Header />
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/battle/create"
            element={
              <ProtectedRoute>
                <CreateBattle />
              </ProtectedRoute>
            }
          />
          <Route
            path="/battle/:id"
            element={
              <ProtectedRoute>
                <BattleDisplay />
              </ProtectedRoute>
            }
          />
          <Route
            path="/subscription"
            element={
              <ProtectedRoute>
                <SubscriptionPlans />
              </ProtectedRoute>
            }
          />

          {/* Redirect root to dashboard if authenticated, otherwise to login */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
